import React from 'react'
import { BankNameConvertor } from 'utilities/helper/bankNameConvertor'
import StarIcon from 'assets/images/star/star.svg'
import ThreeDotsIcon from 'assets/images/three-dots/three-dots.svg'
interface IOpenBank {
    open: boolean
    item: IBankCardsResult | undefined
}
interface ItemProps {
    item: IBankCardsResult
    setIsOpen: React.Dispatch<React.SetStateAction<IOpenBank>>
    isOpen: IOpenBank
}
export default function Item({ item, setIsOpen, isOpen }: ItemProps) {
    return (
        <div className="shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] bg-gradient-to-b from-from-card to-to-card mx-3 my-3 rounded-xl px-4 py-2">
            <div className=" flex justify-between mb-2 mt-3">
                <img
                    src={BankNameConvertor[item.bank_unique_code]}
                    alt="bank"
                />
                {item.is_default && <img src={StarIcon} alt="star" />}
            </div>
            <div className=" my-4 text-xl text-center text-black">
                <p dir="ltr">
                    {item.card_number
                        ? item.card_number
                              .match(/.{1,4}/g)
                              ?.join('\xa0\xa0\xa0\xa0')
                        : item.iban.match(/.{1,4}/g)?.join('\xa0\xa0')}
                </p>
            </div>
            <div className=" mb-2 flex justify-between">
                <p>
                    {item.owner_first_name} {item.owner_last_name}
                </p>
                <img
                    src={ThreeDotsIcon}
                    alt="three-dots"
                    onClick={() => setIsOpen({ open: true, item: item })}
                />
            </div>
        </div>
    )
}
